/* unplugin-vue-components disabled */import script from "./DisTimeDialog.vue?vue&type=script&setup=true&name=DisTimeDialog&lang=js"
export * from "./DisTimeDialog.vue?vue&type=script&setup=true&name=DisTimeDialog&lang=js"

import "./DisTimeDialog.vue?vue&type=style&index=0&id=71ae454a&lang=scss&scoped=true"
import "./DisTimeDialog.vue?vue&type=style&index=1&id=71ae454a&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71ae454a"]])

export default __exports__